module.exports = __webpack_public_path__ + "static/header_background-c2012333fef880ba6bcbb296a301d019.jpg";